export const Create = () => import('./Create.vue');
export const Edit = () => import('./Edit.vue');
export const List = () => import('./List.vue');